import {
    cloudflareDevTunnelPattern,
    isLocalhost
} from '../lib/isLocalOrDevEnvironment.ts';

const getBaseUrl = () => {
    // If running on localhost, use the backend port
    if (isLocalhost) {
        return 'https://localhost:61645';
    }

    // Cloudflare single-origin dev tunnel (dev<N>.thetaassist.ai): the SPA and API
    // share one host, so use relative URLs. The vite dev server proxies /api, /hubs
    // and /hangfire to the backend on localhost:61645.
    if (cloudflareDevTunnelPattern.test(window.location.hostname)) {
        return '';
    }

    // If running on Azure Dev Tunnels, construct backend URL with embedded port
    // Current URL: https://njhdsmxn.aue.devtunnels.ms:8080
    // Backend URL: https://njhdsmxn-61645.aue.devtunnels.ms
    if (window.location.hostname.includes('devtunnels.ms')) {
        const protocol = window.location.protocol;
        const hostname = window.location.hostname;

        // Insert -61645 before the domain suffix
        // Split: njhdsmxn.aue.devtunnels.ms -> [njhdsmxn, aue, devtunnels, ms]
        const parts = hostname.split('.');
        if (parts.length >= 2) {
            // Reconstruct as: njhdsmxn-61645.aue.devtunnels.ms
            const prefix = parts[0];
            const domainSuffix = parts.slice(1).join('.');
            const backendHostname = `${prefix}-61645.${domainSuffix}`;
            return `${protocol}//${backendHostname}`;
        }
    }

    // For production, use relative URLs (same origin)
    return '';
};

const baseUrl = getBaseUrl();

export default baseUrl;
